/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Pulse_Actionverb_Added1Inputs */

const id_home_pulse_actionverb_added1 = /** @type {(inputs: Home_Pulse_Actionverb_Added1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ditambahkan`)
};

const ms_home_pulse_actionverb_added1 = /** @type {(inputs: Home_Pulse_Actionverb_Added1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ditambah`)
};

const da_home_pulse_actionverb_added1 = /** @type {(inputs: Home_Pulse_Actionverb_Added1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tilføjet`)
};

const de_home_pulse_actionverb_added1 = /** @type {(inputs: Home_Pulse_Actionverb_Added1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`hinzugefügt`)
};

const en_us2_home_pulse_actionverb_added1 = /** @type {(inputs: Home_Pulse_Actionverb_Added1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`added`)
};

const es_es2_home_pulse_actionverb_added1 = /** @type {(inputs: Home_Pulse_Actionverb_Added1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`añadido`)
};

const es_mx2_home_pulse_actionverb_added1 = /** @type {(inputs: Home_Pulse_Actionverb_Added1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`agregado`)
};

const fil_home_pulse_actionverb_added1 = /** @type {(inputs: Home_Pulse_Actionverb_Added1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`idinagdag`)
};

const fr_home_pulse_actionverb_added1 = /** @type {(inputs: Home_Pulse_Actionverb_Added1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ajouté`)
};

const it_home_pulse_actionverb_added1 = /** @type {(inputs: Home_Pulse_Actionverb_Added1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aggiunto`)
};

const hu_home_pulse_actionverb_added1 = /** @type {(inputs: Home_Pulse_Actionverb_Added1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`hozzáadva`)
};

const nl_home_pulse_actionverb_added1 = /** @type {(inputs: Home_Pulse_Actionverb_Added1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`toegevoegd`)
};

const no_home_pulse_actionverb_added1 = /** @type {(inputs: Home_Pulse_Actionverb_Added1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lagt til`)
};

const pl_home_pulse_actionverb_added1 = /** @type {(inputs: Home_Pulse_Actionverb_Added1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dodano`)
};

const pt_br2_home_pulse_actionverb_added1 = /** @type {(inputs: Home_Pulse_Actionverb_Added1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`adicionado`)
};

const pt_home_pulse_actionverb_added1 = /** @type {(inputs: Home_Pulse_Actionverb_Added1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`adicionado`)
};

const ro_home_pulse_actionverb_added1 = /** @type {(inputs: Home_Pulse_Actionverb_Added1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`adăugat`)
};

const fi_home_pulse_actionverb_added1 = /** @type {(inputs: Home_Pulse_Actionverb_Added1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lisätty`)
};

const sv_home_pulse_actionverb_added1 = /** @type {(inputs: Home_Pulse_Actionverb_Added1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tillagd`)
};

const vi_home_pulse_actionverb_added1 = /** @type {(inputs: Home_Pulse_Actionverb_Added1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`đã thêm`)
};

const tr_home_pulse_actionverb_added1 = /** @type {(inputs: Home_Pulse_Actionverb_Added1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`eklendi`)
};

const cs_home_pulse_actionverb_added1 = /** @type {(inputs: Home_Pulse_Actionverb_Added1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`přidáno`)
};

const bg_home_pulse_actionverb_added1 = /** @type {(inputs: Home_Pulse_Actionverb_Added1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`добавено`)
};

const ru_home_pulse_actionverb_added1 = /** @type {(inputs: Home_Pulse_Actionverb_Added1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`добавлено`)
};

const uk_home_pulse_actionverb_added1 = /** @type {(inputs: Home_Pulse_Actionverb_Added1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`додано`)
};

const ar_home_pulse_actionverb_added1 = /** @type {(inputs: Home_Pulse_Actionverb_Added1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تمت الإضافة`)
};

const hi_home_pulse_actionverb_added1 = /** @type {(inputs: Home_Pulse_Actionverb_Added1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`जोड़ा गया`)
};

const th_home_pulse_actionverb_added1 = /** @type {(inputs: Home_Pulse_Actionverb_Added1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เพิ่มแล้ว`)
};

const ja_home_pulse_actionverb_added1 = /** @type {(inputs: Home_Pulse_Actionverb_Added1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`追加されました`)
};

const zh_cn2_home_pulse_actionverb_added1 = /** @type {(inputs: Home_Pulse_Actionverb_Added1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已添加`)
};

const zh_hant1_home_pulse_actionverb_added1 = /** @type {(inputs: Home_Pulse_Actionverb_Added1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已新增`)
};

const ko_home_pulse_actionverb_added1 = /** @type {(inputs: Home_Pulse_Actionverb_Added1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`추가됨`)
};

/**
* | output |
* | --- |
* | "added" |
*
* @param {Home_Pulse_Actionverb_Added1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const home_pulse_actionverb_added1 = /** @type {((inputs?: Home_Pulse_Actionverb_Added1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Pulse_Actionverb_Added1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_home_pulse_actionverb_added1(inputs)
	if (locale === "ms") return ms_home_pulse_actionverb_added1(inputs)
	if (locale === "da") return da_home_pulse_actionverb_added1(inputs)
	if (locale === "de") return de_home_pulse_actionverb_added1(inputs)
	if (locale === "en-US") return en_us2_home_pulse_actionverb_added1(inputs)
	if (locale === "es-ES") return es_es2_home_pulse_actionverb_added1(inputs)
	if (locale === "es-MX") return es_mx2_home_pulse_actionverb_added1(inputs)
	if (locale === "fil") return fil_home_pulse_actionverb_added1(inputs)
	if (locale === "fr") return fr_home_pulse_actionverb_added1(inputs)
	if (locale === "it") return it_home_pulse_actionverb_added1(inputs)
	if (locale === "hu") return hu_home_pulse_actionverb_added1(inputs)
	if (locale === "nl") return nl_home_pulse_actionverb_added1(inputs)
	if (locale === "no") return no_home_pulse_actionverb_added1(inputs)
	if (locale === "pl") return pl_home_pulse_actionverb_added1(inputs)
	if (locale === "pt-BR") return pt_br2_home_pulse_actionverb_added1(inputs)
	if (locale === "pt") return pt_home_pulse_actionverb_added1(inputs)
	if (locale === "ro") return ro_home_pulse_actionverb_added1(inputs)
	if (locale === "fi") return fi_home_pulse_actionverb_added1(inputs)
	if (locale === "sv") return sv_home_pulse_actionverb_added1(inputs)
	if (locale === "vi") return vi_home_pulse_actionverb_added1(inputs)
	if (locale === "tr") return tr_home_pulse_actionverb_added1(inputs)
	if (locale === "cs") return cs_home_pulse_actionverb_added1(inputs)
	if (locale === "bg") return bg_home_pulse_actionverb_added1(inputs)
	if (locale === "ru") return ru_home_pulse_actionverb_added1(inputs)
	if (locale === "uk") return uk_home_pulse_actionverb_added1(inputs)
	if (locale === "ar") return ar_home_pulse_actionverb_added1(inputs)
	if (locale === "hi") return hi_home_pulse_actionverb_added1(inputs)
	if (locale === "th") return th_home_pulse_actionverb_added1(inputs)
	if (locale === "ja") return ja_home_pulse_actionverb_added1(inputs)
	if (locale === "zh-CN") return zh_cn2_home_pulse_actionverb_added1(inputs)
	if (locale === "zh-Hant") return zh_hant1_home_pulse_actionverb_added1(inputs)
	return ko_home_pulse_actionverb_added1(inputs)
});
export { home_pulse_actionverb_added1 as "home.pulse.actionVerb.added" }